export default "__VITE_ASSET__a690b75e__"